export enum EnumMasterInsuranceState {
  "draft" = "draft",
  "published" = "published",
  "editing" = "editing",
}
